import React from 'react';
import './Modal2.css'

class Modal2 extends React.Component {
	// stateless component to render a modal 
	// e.g. for loading or error

	render(){
		// format text if passed in props
		let modalText = null;
		if(this.props.modalText){
			modalText = (
				<div className='modal-text'>
					<p>{this.props.modalText}</p>
				</div>
			)
		}

		return (
			<div className="page-container">
				<div className='page-scroll-container'>
					<div className='modal-container'>
						<div className='modal-div'>
							
							{/* Graphics Container */}
							<div className="modal-graphics-container">
								{this.props.rotating ? (
									<div className="modal-3-ring-spinner">
										<div className="ring ring-1"></div>
										<div className="ring ring-2"></div>
										<div className="ring ring-3"></div>
									</div>
								) : (
									<div className="modal-icon-static">
										{/* Only render icon if not loading/rotating */}
										{this.props.icon}
									</div>
								)}
							</div>

							<h2 className='modal-label'> 
								{this.props.label}
							</h2>
							
							{modalText}
							{this.props.children}
							
						</div>
					</div>
				</div>
			</div>
		)
	}
};

export default Modal2;